
function toggleTabs(el) {

	const tabs = [...el.querySelectorAll('.ui-tabbedcontent__tab')]
	var activeTab = el.querySelector('.ui-tabbedcontent__tab.active')

	const content = el.querySelectorAll('.ui-tabbedcontent__contentitem')
	var activeContent = el.querySelector('.ui-tabbedcontent__contentitem.active')

	function clickHandler(event) {
		if (event.currentTarget.nodeName === 'A') return
        const tab = event.currentTarget
		var tabID = parseInt(tab.getAttribute('data-tab') || '')

		content.forEach(item => {
			var contentID = parseInt(item.getAttribute('data-tab') || '')
			if (contentID === tabID) {
                removeClasses()

                activeTab = tab
                tab.classList.add('active')
				tab.setAttribute('aria-selected', 'true')

				activeContent = item
				item.classList.add('active')
			}
		})
	}
	
	function removeClasses() {
		activeTab && activeTab.classList.remove('active')
		activeTab && activeTab.setAttribute('aria-selected', 'false')
		activeContent && activeContent.classList.remove('active')
	}

	tabs.forEach(function(tab) {
		tab.addEventListener('click', clickHandler)
	})
}


export default function init() {
	[...document.querySelectorAll('.ui-tabbedcontent')].map(toggleTabs)
}
